export const getProductName = (productSiloName: string | null, productName: string | null) => {
    const isStandalone = productSiloName && productSiloName === productName;
    const fullProductName = `${productSiloName ? productSiloName + " " : ""}${productName ?? ""}`;

    return isStandalone ? productSiloName : fullProductName;
};

export const getProductNameWithHyphen = (
  productSiloName: string | null,
  productName: string | null
) => {
  const isStandalone = productSiloName && productSiloName === productName;
  const fullProductName = `${productSiloName ?? ""}${productSiloName && productName ? " - " : ""}${
    productName ?? ""
  }`;

  return isStandalone ? productSiloName : fullProductName;
};